import React from "react"
import styled from "styled-components"
import { colors, sizes, breakpoints, mixins } from "../css-variables"

const BreadCrumbSection = styled.div`
    display: none;
    width: 100%;
    margin: 18px auto !important;
    ${mixins.fixed_width_element}
    @media screen and ${breakpoints.tablet} {
      display: flex;
      flex-wrap: wrap;
    }
    @media screen and ${breakpoints.laptopS} {
      max-width: 1128px ;
    }
  `
  const BreadCrumb = styled.div`
    display: flex;
    margin: 0 0 0 3px;
    color: ${colors.textGrey};
    font-size: ${sizes.s14};
    a {
      margin-right: 5px;
      color: ${colors.textGrey} !important;
      cursor: pointer;
      text-decoration: none;
      &:hover{
        text-decoration: underline;
      }
    }
    p {
      margin-bottom: 0;
      
    }
  `
  
const BreadCrumbs = ({ links }) => {
  
  let lastItem = links[links.length - 1]

  let renderedLinks = links.map(link => {
    const notLast = link !== lastItem ? true : false
    return (
      <BreadCrumb key={link.url}>
        {notLast && <a href={link.url}>
          <p>{link.name}</p>
        </a>}
        {notLast && <p>{`>`}</p>}
        {!notLast && <p>{link.name}</p>}
      </BreadCrumb>
    )
  })
  return <BreadCrumbSection>{renderedLinks}</BreadCrumbSection>
}

export default BreadCrumbs